import { ReactNode } from "react";
import { useModal } from "../../../hooks/useModal";
import styles from "./Modal.module.css";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
    width?: string;
    height?: string;
};

export const Modal = ({ isOpen, onClose, children, width, height }: Props) => {
    const { shouldRender, isVisible } = useModal(isOpen, 300);

    if (!shouldRender) return null;

    return (
        <div
            className={`${styles.overlay} ${
                isVisible ? styles.show : styles.hide
            }`}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    onClose();
                }
            }}
        >
            <div className={styles.modal} onClick={(e) => e.stopPropagation()} style={{ width, height }}>
                {children}
            </div>
        </div>
    );
};
